/* eslint-disable @typescript-eslint/no-explicit-any */
import { TPanelOptions } from '@gerdau/hefesto-mais-web/InformationPanel/InformationPanel.types';
import {
  EUserPreferenceType,
  IUserPreference
} from '../../../../store/ducks/user/types';

export type SortDirection = 'asc' | 'desc';

export const defaultOrderUserPreference: IUserPreference = {
  name: EUserPreferenceType.ORDERS,
  ordersItens: {
    idOrder: '0',
    idProduct: '0'
  }
};

export interface HeaderColumnProps {
  title: string;
  column: any;
  options: TPanelOptions[];
  debounce: ({ column, value }: { column: string; value: string }) => void;
  width?: number;
  lastColumns?: boolean;
  value?: string;
}

export const actionsOptions = ({
  onUpdateOrderClick,
  onCancelOrderClick,
  onDownloadOrderClick,
  disableUpdateOrderFn = false,
  disableDownloadOrderFn = false,
  disableCancelOrderFn = false
}: {
  onUpdateOrderClick: () => void;
  onDownloadOrderClick?: () => void;
  onCancelOrderClick: () => void;
  disableUpdateOrderFn?: boolean;
  disableDownloadOrderFn?: boolean;
  disableCancelOrderFn?: boolean;
}): TPanelOptions[] => [
  {
    text: 'Solicitar alterações',
    handleOnClick: onUpdateOrderClick,
    disabled: disableUpdateOrderFn
  },
  ...(onDownloadOrderClick
    ? [
        {
          text: 'Baixar documentos',
          handleOnClick: onDownloadOrderClick,
          disabled: disableDownloadOrderFn
        }
      ]
    : []),
  {
    text: 'Solicitar cancelamento',
    variant: 'danger',
    handleOnClick: onCancelOrderClick,
    disabled: disableCancelOrderFn
  }
];
